/**
 * Concours — animations déco SVG
 * deco1 (.concours-tai__deco) : stroke draw on scroll
 * deco2 (.concours-tai__deco2) : path-by-path opacity on scroll
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    /* deco1 — stroke draw */
    var decos = document.querySelectorAll('.concours-tai__deco');
    decos.forEach(function (svg) {
      var path = svg.querySelector('path');
      if (!path) return;
      var length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
    });

    /* deco2 — init opacity 0 */
    var deco2s = document.querySelectorAll('.concours-tai__deco2');
    deco2s.forEach(function (svg) {
      var paths = svg.querySelectorAll('path');
      paths.forEach(function (p) { p.style.opacity = 0; });
    });

    function onScroll() {
      var windowH = window.innerHeight;

      /* deco1 */
      decos.forEach(function (svg) {
        var path = svg.querySelector('path');
        if (!path) return;
        var length = path.getTotalLength();
        var rect = svg.getBoundingClientRect();
        var start = windowH;
        var end = windowH * 0.3;
        var progress = (start - rect.top) / (start - end);
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        path.style.strokeDashoffset = length * (1 - progress);
      });

      /* deco2 */
      deco2s.forEach(function (svg) {
        var paths = svg.querySelectorAll('path');
        var rect = svg.getBoundingClientRect();
        var start = windowH;
        var end = windowH * 0.5;
        var progress = (start - rect.top) / (start - end);
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        paths.forEach(function (p, i) {
          var pStart = i / paths.length;
          var pEnd = (i + 1) / paths.length;
          var pProg = (progress - pStart) / (pEnd - pStart);
          if (pProg < 0) pProg = 0;
          if (pProg > 1) pProg = 1;
          p.style.opacity = pProg;
        });
        svg.style.opacity = 1;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
